require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-neusiedl-nickelsdorf.json") })
        }
      }, "path---betreuungseinrichtungen-neusiedl-nickelsdorf");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-neusiedl-nickelsdorf!./.cache/json/betreuungseinrichtungen-neusiedl-nickelsdorf.json
// module id = 958
// module chunks = 231608221292675